import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Footer, P } from '../../AbstractElements';
import { Link, useLocation } from 'react-router-dom';

const FooterClass = () => {
  const location = useLocation();

  return (
    <>
      {/* <Footer attrFooter={{ className: `footer ${location.pathname === '/viho/page-layout/footer-dark' ? 'footer-dark' : location.pathname === '/viho/page-layout/footer-fixed' ? 'footer-fix' : ''}` }} >
        <Container fluid={true}>
          <Row>
            <Col md="6" className="footer-copyright">
              <P attrPara={{ className: 'mb-0' }} >{'Copyright 2024-25 © Evtor All rights reserved.'}</P>
            </Col>
            <Col md="6">
              <P attrPara={{ className: 'pull-right mb-0' }} >Hand crafted & made with  Evtor<i className="fa fa-heart font-secondary"></i></P>
            </Col>
          </Row>
        </Container>
      </Footer> */}
      <section className='footer-wrap'>
        <div className='footer-top'>
          <div className='container'>
            <div className='d-flex justify-content-between'>
              <div>
                <h1 class="logo mb-4">Raivens Technologies Pvt. Ltd.</h1>
                  <div className='sm-title mb-0'>Contact Info</div>
                  <p><i class="fa fa-whatsapp">
                  </i> +91-8306006901-02-03</p>
                  <p>
  <i class="fa fa-envelope"></i> support@raivens.com
</p>

<p>
  Raivens Technologies Pvt. Ltd.<br />
  Plot No 4, Laxmi Vilas, Choudhary Colony,<br />
  Sawai Madhopur Road, Tonk,
  Rajasthan, India - 304001
</p>

                  {/* <div className='mt-4 social-links'>
                    <a href="#" className='me-4 d-inline-block'><i class="fa-brands fa-facebook-f"></i></a>
                    <a href="#" className='me-4 d-inline-block'><i class="fa-brands fa-twitter"></i></a>
                    <a href="#" className='me-4 d-inline-block'><i class="fa-brands fa-pinterest"></i></a>
                    <a href="#" className='me-4 d-inline-block'><i class="fa-brands fa-square-instagram"></i></a>
                  </div> */}
              </div>
              <div className='d-flex justify-content-between w-50'>
                <div>
                  <div className='sm-title'>Find In Fast</div>
                  <ul className='ft-menu'>
                    <li>
                      <a href='#'>Search</a>
                    </li>
                  </ul>
                </div>
                <div className='w-50'>
                  <div className='sm-title'>Information</div>
                  <div className='d-flex justify-content-between'>
                    <ul className='ft-menu'>
                      <li>
                        <Link to="/shipping-policy">Shipping Policy</Link>
                      </li>
                      {/* <li>
                  <a href='#'>Contact Information</a>
                      </li> */}
                      <li>
                        <a href='/privacy-policy'>Privacy Policy</a>
                      </li>
                      <li>
                        <a href='/refund-policy'>Refund Policy</a>
                      </li>
                      <li>
                        <a href='/terms-conditions'>Terms of Service</a>
                      </li>
                    </ul>
                    <ul className='ft-menu'>
                      <li>
                        <a href='/home'>Home</a>
                      </li>
                      <li>
                        <a href='#'>Catalog</a>
                      </li>
                      <li>
                        <a href='/about-us'>About Us</a>
                      </li>
                      <li>
                        <a href='#'>Contact</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div>
                <div className='sm-title'>In the Spotlight</div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className='footer-bottom text-center'>
          Copyright 2024-25 &copy; <strong>Evtor</strong> All rights reserved.
        </div> */}
      </section>
    </>
  );
};

export default FooterClass;